type RetryFnProps = {
  params: {
    failureCount: number
    error: any
  }
  stopErrors: number[]
}

/**
 * Function that determines whether a query should be retried based on the error status and failure count.
 * 
 * Ex: 
 * return useQuery({
    queryKey: [`budget-${id}`],
    queryFn: fetcher,
    retry: (failureCount, error: any) =>
      retryFn({ params: { failureCount, error }, stopErrors: [403, 400] }),
    ...options,
  })
 */
export const retryFn = (props: RetryFnProps) => {
  const { params, stopErrors } = props
  const { failureCount, error } = params

  if (stopErrors.includes(error?.status)) {
    return false
  }
  return failureCount < 3
}
